import { RepositoryFactory } from "@/repositories/RepositoryFactory";

const ResourcesRepository = RepositoryFactory.get("resources");

const state = {
  resources: [],
};

const getters = {};

const actions = {
  getResources({ dispatch, commit }, params = {}) {
    ResourcesRepository.getResources(params)
      .then((response) => {
        const resources = response.data.results;
        const totalPages = response.data.total_pages;
        commit("pagination/SET_TOTAL_PAGES", totalPages, { root: true });
        commit("SAVE_RESOURCES", resources);
      })
      .catch(() => {
        dispatch(
          "notifications/addError",
          {
            message: state.$t(
              `message.notifications.resources.getResourcesError`,
            ),
          },
          { root: true },
        );
      });
  },
  updateDescription({ dispatch, commit }, payload = {}) {
    const resourceId = payload.id;

    return ResourcesRepository.updateDescription(resourceId, payload)
      .then(() => {
        commit("UPDATE_RESOURCE_DESCRIPTION", payload);
      })
      .catch(() => {
        dispatch(
          "notifications/addError",
          {
            message: state.$t(
              `message.notifications.resources.updateDescriptionError`,
            ),
          },
          { root: true },
        );
      });
  },
  resetResources({ commit }) {
    commit("RESET_RESOURCES");
  },
};

const mutations = {
  RESET_RESOURCES(state) {
    state.resources = [];
  },
  SAVE_RESOURCES(state, resources) {
    state.resources = resources;
  },
  UPDATE_RESOURCE_DESCRIPTION(state, payload) {
    let i = state.resources.findIndex((r) => r.id === payload.id);
    state.resources[i].description = payload.description;
  },
};

export default {
  namespaced: true,
  getters,
  state,
  actions,
  mutations,
};
